<template>
  <Dialog :commonDialog="dDialog" :dialogWidth="dialogWidth">
    <template v-slot:title>
      <v-layout>
        <v-flex> Payment Term Manage </v-flex>
        <v-flex class="text-right">
          <v-btn
            depressed
            small
            class="mx-4 white--text"
            color="cyan"
            v-on:click="createContractType"
          >
            <span class="font-size-16 font-weight-600">Add Payment Term</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll custom-box-top-inner-shadow"
        style="max-height: 90vh; position: relative"
      >
        <v-form
          ref="ticketCollecttionForm"
          v-model.trim="formValid"
          lazy-validation
        >
          <v-container class="py-0">
            <v-row class="py-0">
              <v-col md="12" class="py-0">
                <table class="width-100">
                  <tbody>
                    <tr v-for="(type, index) in payment_term" :key="index">
                      <td>
                        <v-text-field
                          v-model.trim="type.text"
                          dense
                          filled
                          placeholder="Payment Term"
                          solo
                          flat
                          class="px-4 py-2"
                          hide-details
                          :disabled="pageLoading"
                          :loading="pageLoading"
                          :readonly="Boolean(type.id)"
                          :rules="[
                            validateRules.required(type.text, 'Payment Term'),
                          ]"
                          color="cyan"
                        ></v-text-field>
                      </td>
                      <td width="50" v-if="payment_term.length > 1">
                        <v-tooltip top content-class="custom-top-tooltip">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-on:click="deleteContractType(index)"
                              :disabled="Boolean(type.id)"
                              color="deep-orange"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-delete</v-icon
                            >
                          </template>
                          <span>Click here to delete</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </perfect-scrollbar>
    </template>
    <template v-slot:action>
      <v-btn
        depressed
        :disabled="pageLoading || !formValid"
        :loading="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button white--text"
        color="cyan"
        v-on:click="savePaymentTerms"
      >
        Save
      </v-btn>
      <v-btn
        depressed
        :disabled="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="$emit('close-dialog', true)"
      >
        Close
      </v-btn>
    </template>
  </Dialog>
</template>
<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import { POST } from "@/core/services/store/request.module";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";
import CommonMixin from "@/core/plugins/common-mixin";
import { cloneDeep } from "lodash";
export default {
  mixins: [ValidationMixin, CommonMixin],
  props: {
    dDialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    e_paymentTerm: {
      type: Array,
      default: () => {
        return new Array();
      },
    },
    existCategory: {
      type: Number,
      default: null,
    },
  },
  watch: {
    dDialog(value) {
      if (value) {
        this.payment_term = cloneDeep(this.e_paymentTerm);
        this.formValid = true;
      }
    },
    e_paymentTerm: {
      deep: true,
      immediate: true,
      handler(param) {
        this.payment_term = cloneDeep(param);
      },
    },
  },
  data: () => {
    return {
      formValid: true,
      pageLoading: false,
      payment_term: [
        {
          text: null,
        },
      ],
    };
  },
  methods: {
    async savePaymentTerms() {
      const formErrors = this.validateForm(this.$refs.ticketCollecttionForm);
      if (formErrors.length) {
        formErrors.forEach((error) => {
          ErrorEventBus.$emit("update:error", InitializeError(error));
        });
        return false;
      }

      const newTerms = this.payment_term.filter((term) => !term.id);
      if (!newTerms.length) {
        this.$emit("close-dialog", true);
        return true;
      }

      this.pageLoading = true;
      try {
        const createdTerms = [];
        for (let index = 0; index < newTerms.length; index++) {
          const response = await this.$store.dispatch(POST, {
            url: "purchase-order/payment-terms",
            data: {
              text: newTerms[index].text,
            },
          });
          if (response && response.data) {
            createdTerms.push(response.data);
          }
        }
        this.$emit("payment-terms-updated", createdTerms);
        this.$emit("close-dialog", true);
        return true;
      } catch (error) {
        this.logError(error);
        return false;
      } finally {
        this.pageLoading = false;
      }
    },
    createContractType() {
      this.payment_term.push({
        text: null,
      });
    },
    deleteContractType(index) {
      if (!this.payment_term[index].id && this.payment_term.length > 1) {
        this.payment_term.splice(index, 1);
      }
    },
  },
  components: {
    Dialog,
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },
  },
};
</script>
